import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./Tabs.module.scss";
import React, { ReactNode, useState } from "react";
import classnames from "classnames";

interface IProps {
  titleFirst: string;
  titleSecond: string;
  tabContentFirst: ReactNode;
  tabContentSecond: ReactNode;
}

export const TabsList = ({ titleFirst, titleSecond, tabContentFirst, tabContentSecond }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  const selectedButtonMods = classnames(styles.tabButtonActive, styles.tabButton, {
    [styles.selectedTabButtonLeft]: tabIndex === 1,
    [styles.selectedTabButtonRight]: tabIndex === 0,
    [styles.unselectedTabButtonLeft]: tabIndex === 1,
    [styles.unselectedTabButtonRight]: tabIndex === 0,
  });

  const unselectedButtonMods = classnames(styles.tabButton, {
    [styles.selectedTabButtonLeft]: tabIndex === 0,
    [styles.selectedTabButtonRight]: tabIndex === 1,
    [styles.unselectedTabButtonLeft]: tabIndex === 0,
    [styles.unselectedTabButtonRight]: tabIndex === 1,
  });

  return (
    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
      <TabList className={styles.tabList}>
        <Tab selectedClassName={selectedButtonMods} className={tabIndex === 1 ? unselectedButtonMods : ""}>
          {titleFirst}
        </Tab>
        <Tab selectedClassName={selectedButtonMods} className={tabIndex === 0 ? unselectedButtonMods : ""}>
          {titleSecond}
        </Tab>
      </TabList>
      <TabPanel className={styles.tabPanel}>{tabContentFirst}</TabPanel>
      <TabPanel>{tabContentSecond}</TabPanel>
    </Tabs>
  );
};
